import type { components } from '@/shared/api/schema'

export type CurrentAdmin = components['schemas']['CurrentAdminResource']

/**
 * Permissões seguem o catálogo da API: "<modulo>.view" e "<modulo>.manage"
 * (apps/api/app/Support/Authorization/PermissionCatalog.php).
 *
 * Usadas apenas para esconder menus e telas: a autorização real é feita no servidor.
 */
export type Permission = `${string}.${'view' | 'manage'}`

export function can(admin: CurrentAdmin | undefined, permission: Permission | undefined): boolean {
  if (!admin) return false
  if (!permission) return true

  // Módulo desabilitado no tenant: nem o super-admin enxerga.
  if (!admin.enabled_modules.includes(permission.split('.')[0] ?? '')) return false

  return admin.is_super_admin || admin.permissions.includes(permission)
}
